<div ngClass="error-page">		
	<ng-content select="div,span,h1,h2,h3,h4,h5,h6,p,br"></ng-content>
	<ng-content select="button"></ng-content>
</div>
